module.exports = hasKeys

function hasKeys(source) {
    return source !== null &&
        (typeof source === "object" ||
        typeof source === "function")
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/xtend/has-keys.js
 ** module id = 679
 ** module chunks = 0
 **/